import React, { useEffect, useState, useMemo } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Plus, Search, ShieldCheck } from 'lucide-react';

const PrecautionList = () => {
  const [precautions, setPrecautions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    axios.get('/api/precautions').then(res => setPrecautions(res.data.data || []));
  }, []);

  const filteredData = useMemo(() => precautions.filter(p => 
    p.precautionnum.toLowerCase().includes(searchTerm.toLowerCase()) || (p.description || "").toLowerCase().includes(searchTerm.toLowerCase())
  ), [precautions, searchTerm]);

  return (
    <div className="flex flex-col h-full bg-[#f3f4f6] text-[11px] font-sans uppercase font-bold">
      <div className="bg-white p-3 border-b shadow-sm flex justify-between items-center">
        <h2 className="text-[#005495] font-black italic text-lg flex items-center gap-2"><ShieldCheck size={20}/> Precaution Master Library</h2>
        <div className="flex gap-4">
          <div className="relative"><Search className="absolute left-3 top-2 text-gray-400" size={14} /><input className="pl-9 pr-4 py-1.5 border border-gray-300 w-80 outline-none rounded-sm" placeholder="Search Precautions..." value={searchTerm} onChange={(e)=>setSearchTerm(e.target.value)}/></div>
          <button onClick={() => navigate('/precautions/new')} className="bg-[#3c70a4] text-white px-6 py-2 rounded-sm font-black flex items-center gap-2 shadow-md"><Plus size={16}/> NEW PRECAUTION</button>
        </div>
      </div>
      <div className="flex-1 overflow-auto p-4 text-left">
        <div className="bg-white border shadow-sm">
          <table className="w-full">
            <thead className="bg-[#f9fafb] border-b text-gray-400 font-black">
              <tr><th className="p-2 border-r w-40">Num</th><th className="p-2 border-r text-left">Precaution Instruction</th><th className="p-2 text-center w-24">Site</th></tr>
            </thead>
            <tbody>
              {filteredData.map((p, i) => (
                <tr key={i} className="border-b hover:bg-blue-50 cursor-pointer" onClick={() => navigate(`/precautions/${p.precautionnum}`)}>
                  <td className="p-2.5 border-r text-blue-900 font-black">{p.precautionnum}</td>
                  <td className="p-2.5 border-r text-gray-600 font-black">{p.description}</td>
                  <td className="p-2.5 text-center text-gray-400">{p.siteid}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PrecautionList;